import { onSyncEvent } from "../../../services/firebase/firestoreSyncService";
import {
  trackOfflineEntered,
  trackOfflineExited,
  trackOfflineSyncFailed,
} from "../service/analyticsService";

let offlineActive = false;

export function wireSyncAnalytics() {
  return onSyncEvent(({ type, detail }) => {
    if (type === "offline") {
      if (!offlineActive) {
        offlineActive = true;
        trackOfflineEntered({ phase: detail?.phase || "offline" });
      }
      return;
    }
    if (type === "online" && offlineActive) {
      offlineActive = false;
      trackOfflineExited({ phase: detail?.phase || "online" });
      return;
    }
    if (type === "error") {
      const message =
        typeof detail?.message === "string" ? detail.message : "sync_error";
      trackOfflineSyncFailed({ reason: message.slice(0, 80) });
    }
  });
}

export function resetSyncAnalyticsStateForTests() {
  offlineActive = false;
}
